import React from 'react';
import { styled } from 'styled-components';

import { hoverOpacity } from '../helpers/helpers';
import { Icon } from '../icon';
import { FC } from 'react';
import MdChevronLeft from '../icons/angle-left-solid.svg';

export const BackButtonContainer = styled.button`
    padding: 10px 0;
    background: none;
    border: none;
    color: ${(props) => props.theme.app.secondary};
    font-family: ${(props) => props.theme.app.font};
    font-size: 14px;
    font-weight: 800;
    display: flex;
    align-items: center;
    text-transform: none;
    ${hoverOpacity()}

    &:focus {
        outline: none;
    }

    ${Icon} {
        margin-right: 2px;
    }
`;

interface BackButtonProps {
    onClick?: () => void;
    className?: string;
    children?: React.ReactNode;
    isStep?: boolean;
}

export const BackButton: FC<BackButtonProps> = ({ onClick, className, children }) => {
    const handleClick = () => {
        // Emit custom event to allow other components (e.g. unsaved-changes guard) to intercept navigation
        const navigationEvent = new CustomEvent('app-navigate-request', {
            detail: { isBack: true },
            cancelable: true
        });
        const allowed = window.dispatchEvent(navigationEvent);
        if (!allowed) return;

        if (onClick) {
            onClick();
            return;
        }
        window.history.back();
    };

    return (
        <BackButtonContainer className={className} onClick={handleClick}>
            <Icon>
                <MdChevronLeft />
            </Icon>
            {children ?? 'Back'}
        </BackButtonContainer>
    );
};
